import Button from "@mui/material/Button";
import { isValidURL } from "core/utils/isValidURL";

interface CTAButtonProps {
  href: string;
  text: string;
}

export function CTAButton({ href, text }: CTAButtonProps) {
  const validHref = isValidURL(href) ? href : `https://${href}`;
  return (
    <Button
      variant="contained"
      size="large"
      href={validHref}
      target="_blank"
      color="primary"
      sx={{ borderRadius: "16px" }}
    >
      {text}
    </Button>
  );
}
